import { render, staticRenderFns } from "./addCloseDates.vue?vue&type=template&id=4b8d2783&"
import script from "./addCloseDates.vue?vue&type=script&lang=js&"
export * from "./addCloseDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports